<template>
  <section class="container">
    <div class="btn_box">
      <div>
        <div class="my_car" v-for=" (item,index) in park" :key="index" @click="GoJump(item)">
          <div class="my_car__hb">
            <div :class="'header header'+(index+1)">
              <div class="header__unavailable">
                <span class="header__unavailable__title">车位:{{item.parkingNumber}}</span>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { DatetimePicker, Divider, Field, Toast, Picker, Popup, Tab, Tabs, Row, Col, Icon, NoticeBar } from 'vant'
import { queryParkingLot } from '@/api/park'
import keyboard from '@/components/keyboard/index'
import { getUrlParam } from '@/utils'
import { parseTime } from '@/utils'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Pay-Parking-Cost',
  components: {
    keyboard,
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Divider.name]: Divider,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Picker.name]: Picker,  },
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: [],
      columns: [],
      park: [],
      time: null,
      showTimePicker: false,
      showPicker: false,
      minDate: new Date(),
      currentDate: new Date(),
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token', 'jntcImg', 'imgBtn'])
  },
  mounted () {
    this.handleRefresh()
  },
  methods: {
    GoJump (val) {
      if (val) {
        this.$router.push({
          name: 'Reserve-Pay',
          query: { data: val },
        })
      } else {
        this.$toast('暂不支持预约车位')
      }
    },
    handleRefresh () {
      let params = {
        parkId: 670 //停车场类型
      }
      queryParkingLot(params).then(res => {
        this.park = res.body.data
        console.log(this.park)
      }).catch(err => {
        this.$toast(err)
      })
    },


  },

}
</script>

<style lang="scss" scoped>
.container {
  .my_car {
    &__hb {
      padding: 5px 6.85vw 5px;
      .header1 {
        background: url(../../assets/BlpCardbg1.png);
      }
      .header2 {
        background: url(../../assets/BlpCardbg2.png);
      }
      .header3 {
        background: url(../../assets/BlpCardbg3.png);
      }
      .header4 {
        background: url(../../assets/BlpCardbg4.png);
      }

      .header {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        min-height: 120px;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: flex-start;
        &__untied-btn {
          height: 80%;
          width: 33%;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          /deep/ .van-button--plain {
            background-color: rgba(0, 0, 0, 0);
          }
        }

        &__unavailable {
          width: 100%;
          text-align: center;
          position: relative;
          &__title {
            display: block;
            color: #fff;
            font-size: 24px;
            font-weight: 500;
            line-height: -30px;
            color: black;
          }

          &__content {
            display: block;
            font-size: 14px;
            color: #eaf4ff;
          }
          &__btn {
            position: absolute;
            bottom: 10px;
            right: 25px;
            padding: 10px;
          }
        }
      }
    }
  }
  .order {
    background: #ffffff;
    margin-bottom: 10px;

    &__icon {
      font-size: 20px;
      color: #4b62ec;
      line-height: 24px;
      margin-right: 8px;
      height: 24px;
    }

    &__id {
      color: #444444;
      font-size: 16px;
      padding: 12px 16px;
      border-bottom: 1px solid #f3f4f5;
      background: #fff;
    }

    /deep/ .van-cell__title {
      color: #444444;

      .order__info {
        font-size: 16px;
        // text-align: right;
      }

      .order__money {
        font-size: 18px;
        color: #49a6ff;
      }
    }
  }
  .btn_box {
    // padding: 0 15px;
  }
}
</style>